import React from "react";
import { Badge } from "../components/ui/badge";
import { Button } from "../components/ui/button";
import { Card, CardContent, CardDescription, CardHeader, CardTitle } from "../components/ui/card";
import { Separator } from "../components/ui/separator";

import { useState } from "react";
import { useModelCreate, useModelIndex, useModelUpdate } from "@rhino-project/core/hooks";
import { asSubmission, listResults } from "../lib/thirdDoorAdapters";

export default function ReadinessRouting() {
    const [recommendation, setRecommendation] = useState({
      mechanism: "Innovation capability challenge intake",
      navigator: "Assigned: A. Tremblay",
      dia: "DIA Coordination Cell",
      nextStep: "Sponsor technical fit review within 5 business days",
    });
    const [message, setMessage] = useState("");
    const { resources: submissionResources } = useModelIndex("submission" as any, { limit: 1 } as any);
    const submission = asSubmission(listResults(submissionResources)[0] ?? {});
    const { resources: recommendationResources } = useModelIndex("routing_recommendation" as any, { limit: 1 } as any);
    const currentRecommendation = listResults(recommendationResources)[0];
    const { mutate: updateRoutingRecommendation } = useModelUpdate("routing_recommendation" as any);
    const { mutate: createCommunication } = useModelCreate("communication" as any);
    const acceptRecommendation = () => {
      if (currentRecommendation?.id) updateRoutingRecommendation({ id: currentRecommendation.id, status: "accepted", dia_coordination_status: "handoff_package" } as any);
      setMessage("Recommendation accepted. Preparing handoff package and navigator checklist.");
    };
    const requestReview = () => {
      if (submission.id) createCommunication({ submission_id: submission.id, body: "Navigator review requested", communication_type: "review_request", status: "requested" } as any);
      setRecommendation((prev) => ({ ...prev, nextStep: "Review requested: triage board reassessment pending" }));
      setMessage("Review requested. A navigator will follow up with suggested edits.");
    };
  return (
   <div className="w-full min-w-0 bg-background text-foreground overflow-x-hidden">
      <div className="mx-auto flex w-full max-w-7xl min-w-0 flex-col gap-6 px-4 py-6 sm:px-6 lg:px-8">
          <section className="w-full grid gap-6 lg:grid-cols-2">
      <Card className="border-border shadow-sm">
      <CardHeader>
      <CardTitle>Clearance &amp; Accreditation Sequencing</CardTitle>
      <CardDescription>Understand which readiness requirements are needed now, later, or when sponsor interest is confirmed.</CardDescription>
      </CardHeader>
      <CardContent className="space-y-3 text-sm">
      <div className="rounded-lg border border-border p-3">
      <Badge>Available Now</Badge>
      <p className="mt-2 text-muted-foreground">No prerequisite blockers for this stage.</p>
      </div>
      <div className="rounded-lg border border-border p-3">
      <Badge variant="secondary">Deferred</Badge>
      <p className="mt-2 text-muted-foreground">Required once sponsor interest and pathway fit are confirmed.</p>
      </div>
      <div className="rounded-lg border border-border p-3">
      <Badge variant="outline">Triggered Later</Badge>
      <p className="mt-2 text-muted-foreground">Initiated when entering mechanism-specific implementation phases.</p>
      </div>
      <p className="text-xs text-muted-foreground">Sequencing guidance explains the no contract without clearance / no clearance without contract barrier without lowering requirements.</p>

      </CardContent>
      </Card>

      <Card className="border-primary/20 shadow-sm">
      <CardHeader>
      <CardTitle>Routing Recommendation</CardTitle>
      <CardDescription>Review recommendation, assigned navigator, and next coordinated handoff step.</CardDescription>
      </CardHeader>
      <CardContent className="space-y-3 text-sm">
      <p><span className="font-medium">Best-fit mechanism:</span> {recommendation.mechanism}</p>
      <p><span className="font-medium">Assigned navigator:</span> {recommendation.navigator}</p>
      <p><span className="font-medium">DIA coordinating function:</span> {recommendation.dia}</p>
      <p><span className="font-medium">Next handoff step:</span> {recommendation.nextStep}</p>
      <Separator />
      <div className="flex flex-wrap gap-3">
      <Button onClick={acceptRecommendation}>Accept and Continue</Button>
      <Button variant="outline" onClick={requestReview}>Request Review</Button>
      </div>
      {message ? <p className="text-xs text-muted-foreground">{message}</p> : null}
      </CardContent>
      </Card>
      </section>
      </div>
    </div>
  );
}